import { endpointHandler } from '../../endpoints';
const {
  electronicSignatureEndpoint,
  revokeElectronicSignatureEndpoint,
  getCryptoSignatureEndpoint,
  getSatCryptoSignatureEndpoint,
} = endpointHandler();

export const electronicSignatureAPI = (data, reqConfig, urlVar) => {
  return electronicSignatureEndpoint.post(data, reqConfig, urlVar);
};

export const revokeElectronicSignatureAPI = (reqConfig, urlVar) => {
  return revokeElectronicSignatureEndpoint.delete(reqConfig, urlVar);
};

export const getCryptoSignatureAPI = (reqConfig, urlVar) => {
  return getCryptoSignatureEndpoint.get(reqConfig, urlVar);
};

export const getSatCryptoSignatureAPI = (reqConfig, urlVar) => {
  return getSatCryptoSignatureEndpoint.get(reqConfig, urlVar);
};
